<template>
    <multiselect
            v-model="value"
            track-by="name"
            label="name"
            placeholder="Select one"
            v-bind:options="options"
            v-bind:multiple="true"
            v-bind:close-on-select="false"
            v-bind:clear-on-select="false"
    >
        <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
                    v-if="values.length > (maxCount || 5) && !isOpen"
                    v-bind:class="{'someselected': values.length !== options.length}"
            >{{ values.length }} {{filterTypePlural || 'options'}} selected</span>
            <span
                    v-else-if="values.length && !isOpen"
                    v-bind:class="{'someselected': values.length !== options.length}"
            >{{ values.map(x => x.name).join(', ')}}</span>
        </template>
    </multiselect>
</template>

<script>
    export default {
        name: "Dropdown",
        props: ['options', 'maxCount', 'filterTypePlural'],
        data: function () {
            return {
                value: this.options,
            }
        },
        watch: {
            options: function () {
                this.value = this.options;
            },
            value: function (new_val, old_val) {
                if (new_val.length === 0 && old_val.length === 1) {
                    let old_name = old_val[0].name;
                    this.value = this.options.filter(x => x.name !== old_name);
                } else if (new_val.length === (this.options.length - 1) && old_val.length === this.options.length) {
                    this.options.forEach(x => {
                        if (!new_val.includes(x)) {
                            this.value = [x]
                        }
                    });
                }
                let value = this.value.map(v => v.statevalue || v.name)
                value.sort()
                if (value.length) {
                    this.$emit("input", value)
                }
            }
        }
    }
</script>

<style scoped>

/deep/ .multiselect__option--selected.multiselect__option--highlight {
  background: #41b883;
}

/deep/ .multiselect__option--selected.multiselect__option--highlight:after {
  background: #41b883;
}

/deep/ .multiselect__option--group-selected.multiselect__option--highlight {
  background:#41b883;
}

/deep/ .multiselect__option--group-selected.multiselect__option--highlight:after {
  background: #41b883;
}

/deep/ .multiselect__option>span:before {
  content: "☐ ";
}

/deep/ .multiselect__option--selected>span:before {
  content: "☑ ";
}

div {
    margin: 3px 0;
    min-width: 0;
}

.someselected {
    font-weight: bold;
    color: #000;
}
</style>
